export default {
  get token() {
    return localStorage.getItem("token") || "";
  },
  set token(val) {
    localStorage.setItem("token", val);
  },
  get menus() {
    const data = localStorage.getItem("menus");
    return data ? JSON.parse(data) : [];
  },
  set menus(arr) {
    localStorage.setItem("menus", JSON.stringify(arr));
  },
  isKf: null,
};
